import { resolve } from "upath";
var userData = JSON.parse(localStorage.GFMS_USER || "{}");
const user = {
  state: {
    token: "",
    ServiceToken: "",
    isLogin: userData.isLogin || ""
  },
  mutations: {
    SET_IS_Login (state, data) {
      state.isLogin = data.isLogin;
      localStorage.setItem("GFMS_USER", data.isLogin);
    },
    SET_Prouduct_TOKEN (state, data) {
      state.token = data;
    },
    SET_ProuductService_TOKEN (state, data) {
      state.ServiceToken = data;
    },
  },
  getters: {
    token: (state) => {
      return state.token;
    },
    productServiceToken: (state) => {
      return state.ServiceToken;
    },
    isLogin: (state) => {
      return !!state.isLogin;
    },
  },
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js